module.exports = __webpack_public_path__ + "img/07.9005d31c.png";